import { render, staticRenderFns } from "./WorkClaimTasks.vue?vue&type=template&id=03d4573f&scoped=true&"
import script from "./WorkClaimTasks.vue?vue&type=script&lang=js&"
export * from "./WorkClaimTasks.vue?vue&type=script&lang=js&"
import style0 from "./WorkClaimTasks.vue?vue&type=style&index=0&id=03d4573f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03d4573f",
  null
  
)

export default component.exports